import {
  Dumbbell,
  Footprints,
  LayoutDashboard,
  Ruler,
  Utensils,
} from "lucide-react";

import { cn } from "@/lib/utils";
import { Link } from "react-router";
import { useMeasurementInfo } from "@/hooks/measurement/use-measurement-info";
import { useSecretAccess } from "@/hooks/use-secret-access";

const navItems = [
  {
    title: "Головна",
    url: "/",
    icon: LayoutDashboard,
  },
  {
    title: "Раціон",
    url: "/nutrition",
    icon: Utensils,
  },
  {
    title: "Вправи",
    url: "/exercise",
    icon: Dumbbell,
  },
  {
    title: "Кроки",
    url: "/steps",
    icon: Footprints,
  },
  {
    title: "Заміри",
    url: "/measurements",
    icon: Ruler,
    type: "measurements" as const,
  },
];

const NavUser = () => {
  const currentPath = window.location.pathname;
  const { handleSecretClick, isActivating, currentClicks } = useSecretAccess();

  const weightInfo = useMeasurementInfo("weight");
  const shoulderInfo = useMeasurementInfo("shoulder");
  const chestInfo = useMeasurementInfo("chest");
  const waistInfo = useMeasurementInfo("waist");
  const hipsInfo = useMeasurementInfo("hips");
  const hipInfo = useMeasurementInfo("hip");

  const hasEmptyMeasurements =
    weightInfo.canCreate ||
    shoulderInfo.canCreate ||
    chestInfo.canCreate ||
    waistInfo.canCreate ||
    hipsInfo.canCreate ||
    hipInfo.canCreate;

  const handleItemClick = (item: (typeof navItems)[0]) => {
    // Секретный доступ только для "Головна"
    if (item.title === "Головна") {
      const secretActivated = handleSecretClick();
      // Если секрет активирован, не выполняем обычную навигацию
      if (secretActivated) {
        return;
      }
    }
  };

  return (
    <div className="flex justify-around items-center w-full">
      {navItems.map((item) => (
        <Link
          key={item.url}
          to={item.url}
          onClick={() => handleItemClick(item)}
          className={cn(
            "flex flex-col items-center p-2 rounded-md transition-all duration-200 relative",
            currentPath === item.url
              ? "text-primary"
              : "text-muted-foreground hover:text-foreground",
            // Визуальный эффект при активации секрета
            item.title === "Головна" &&
              isActivating &&
              "animate-pulse bg-primary/20 scale-105",
            // Эффект при накоплении кликов
            item.title === "Головна" &&
              currentClicks > 0 &&
              currentClicks < 10 &&
              `ring-${Math.min(currentClicks, 4)} ring-primary/30`
          )}
        >
          <item.icon
            className={cn(
              "h-5 w-5 transition-transform",
              item.title === "Головна" && currentClicks > 5 && "animate-bounce"
            )}
          />
          <span className="text-xs mt-1">{item.title}</span>
          {item.type === "measurements" && hasEmptyMeasurements && (
            <div className="absolute top-2 right-2 w-2 h-2 bg-destructive rounded-full" />
          )}
        </Link>
      ))}
    </div>
  );
};

export default NavUser;
